import React, { useContext, useState } from "react";
import { Container, CardBodyContainer } from "./styles";
import { Heading, HeadingContainer } from "@widgets/multipleCouponCard/styles";
import { Context } from "@components/useContext/context";
import { Flex } from "@acko-tech/building-blocks.ui.common";
import PercentIcon from "@public/images/discount-percentage-icon.svg";
import { CommonProps } from "@utils/interface";
import CloneChildren from "@components/children";
import { connect } from "react-redux";
import { getWidgetSpecificProps } from "@utils/index";

export const EXPANDABLES = {
    IDV: "IDV",
    PLAN: "PLAN"
};
interface ICoveragePricing extends CommonProps { }

const mapStateToProps = function (state: any, ownProps: any) {
    return getWidgetSpecificProps(
        state.configuration?.normalisedConfig,
        ownProps.id
    );
};

const CoveragePricing: React.FC = ({
    children,
    cardTitle,
    ...props
}: any) => {
    const [expanded, setExpanded] = useState<boolean | string>("");
    const { is_visible } = props;

    const { isDesktop } = useContext(Context);

    if (!is_visible) {
        return null;
    }

    return (
        <Container>
            <HeadingContainer
                onClick={(e) => {
                    e.stopPropagation();
                }}
                isDesktop={isDesktop}
                id="heading-container"
            >
                <Flex
                    alignItems="center"
                    styles={{
                        boxSizing: "border-box",
                        gap: "8px",
                        width: "auto"
                    }}
                >
                    <div style={{ width: "24px", height: "24px" }}>
                        <PercentIcon />
                    </div>
                    <Heading>{cardTitle} </Heading>
                </Flex>
            </HeadingContainer>
            <CardBodyContainer>
                <CloneChildren
                    children={children}
                    props={{ expanded: expanded, setExpanded: setExpanded, ...props }}
                />
            </CardBodyContainer>
        </Container>
    );
};

export default connect(mapStateToProps)(CoveragePricing);
